import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/** Route guard for the Client Portal (`/portal/*`).
 *
 * Portal users are ordinary tenant users — no separate identity system,
 * per the licensing plan's "separate identity from application
 * authorization" principle. Unauthenticated visitors go to the regular
 * `/login` (not a dedicated portal login, unlike SuperAdminRoute), and
 * land back on `/portal` after signing in.
 */
export default function PortalRoute({ children }) {
    const { user } = useAuth();
    const location = useLocation();
    if (user === undefined) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-white">
                <div className="font-mono text-xs uppercase tracking-widest text-slate-400">
                    Authenticating…
                </div>
            </div>
        );
    }
    if (user === null) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname + location.search }}
            />
        );
    }
    return children;
}
